import React from 'react';
import Slider from 'react-slick';
import ReactPlayer from 'react-player/lib/players/YouTube';
import shortid from 'shortid';
import Slide from './BannerSlide';
import { LeftArrowIcon, RightArrowIcon, CloseIcon } from '../../managers/IconManager';
import ProjectSlider from './ProjectSlider';

class IOSImageSlider extends ProjectSlider {
  constructor(props) {
    super(props);

    this.onStart = this.onStart.bind(this);
    this.onEnded = this.onEnded.bind(this);
    this.onPlay = this.onPlay.bind(this);

    this.state = {
      ...this.state,
      showInfo: true,
      initial: true,
      isFull: true,
      playVideo: false,
      autoplay: false,
      videoStarted: false,
      nav1: null,
      nav2: null,
      nav3: null,
    };

    this.projects = this.props.projects;
    this.customClasses.dot = {
      normal: 'project_slider__dot--round',
      active: 'project_slider__dot--round--active',
    };
    this.responsive = [
      {
        breakpoint: 1,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ];
    this.settings = {
      ...this.settings,
      slidesToShow: 1,
      slidesToScroll: 1,
      onInit: () => {
        this.setState({
          autoplay: false,
        });
      },
      onReInit: () => {
        const breakpointer = 1;
        const { breakpoint } = this.state;
        if (this.slider && breakpoint !== breakpointer) {
          this.setState({
            autoplay: false,
            initial: false,
            breakpointer,
            pageCount: this.getPageCount(breakpointer),
            slidesToShow: this.getSlidesToShow(breakpointer),
          });
        }
      },
      responsive: this.responsive,
    };
  }

  componentDidMount() {
    const { slideIndex } = this.props;
    this.setState({
      nav1: this.slider,
      nav2: this.slider2,
      nav3: this.slider3,
    });
    this.dotClicked(slideIndex, true);
  }

  getCurrentProject() {
    const { currentPage } = this.state;
    const index = currentPage || 0;
    const project = this.projects[index];
    return project;
  }

  getVideo() {
    const project = this.getCurrentProject();
    return `https://www.youtube.com/watch?v=${project.embedUrl}`;
  }

  isVideo() {
    const project = this.getCurrentProject();
    return project.embedUrl;
  }

  showVideo() {
    this.setState({
      playVideo: true,
      autoplay: false,
      videoStarted: false,
    });
  }

  onStart() {
    // Used to show close button after video starts playing
    this.setState({
      videoStarted: true,
    });
  }

  onPlay() {
    // Used to show close button after video starts playing
    this.setState({
      videoStarted: true,
    });
  }

  onEnded() {
    // Used to show close button after video starts playing
    console.log(`video onEnded : ${this.state.videoStarted}`);
    this.setState({
      videoStarted: false,
      playVideo: false,
    });
  }

  getVideoPlayer() {
    const { playVideo, isFull } = this.state;
    return (
      <div>
        <div className={!playVideo ? ' ' : ' banner_slider__video-wrapper--fix'}>
          <div
            className={
              !playVideo
                ? 'banner_slider--hide '
                : ` banner_slider--aspect ${isFull ? ' banner_slider--aspect--fullscreen ' : ''}`
            }
          >
            <div className="banner_slider__video-wrapper ">
              <ReactPlayer
                className="react-player"
                onStart={this.onStart}
                onEnded={this.onEnded}
                onPlay={this.onPlay}
                url={this.getVideo()}
                height="100%"
                width="100%"
                config={{
                  youtube: {
                    playerVars: {
                      autoplay: '0',
                      enablejsapi: '1',
                      modestbranding: '0',
                      rel: '0',
                      showinfo: '0',

                      // https://developers.google.com/youtube/player_parameters
                    },
                  },
                }}
                controls
                playing={playVideo}
              />
            </div>
          </div>
          {!isFull ? this.getVideoCloseBtn() : ''}
        </div>
        {isFull ? this.getVideoCloseBtn() : ''}
      </div>
    );
  }

  getVideoCloseBtn() {
    const { isFull, playVideo, videoStarted } = this.state;
    return (
      <button
        type="button"
        className={`banner_slider__arrow banner_slider__close--top_right ${
          isFull ? ' banner_slider__close--top_right--full ' : ' '
        }${
          playVideo ? ' banner_slider__close--top_right--play ' : ' '
        }  project_slider__button banner_slider__close `}
        onClick={() => this.setState({
          playVideo: false,
          videoStarted: false,
          autoplay: false,
        })
        }
      >
        {CloseIcon(
          `project_slider__icon project_slider__icon--big ${
            !videoStarted ? 'banner_slider--invisible' : ' banner_slider--visible'
          }`,
        )}
      </button>
    );
  }

  getContentSlider(setSlider) {
    const { playVideo, autoplay } = this.state;
    return (
      <div>
        <div className="banner_slider__container--bg " />
        <div
          className={
            playVideo ? ' banner_slider--hide ' : 'banner_slider--absolute banner_slider--100hw'
          }
        >
          <Slider
            ref={(c) => {
              if (setSlider) {
                this.slider = c;
              } else {
                this.slider3 = c;
              }
            }}
            {...this.settings}
            autoplay={autoplay}
          >
            {this.projects.map(project => (
              <Slide key={`slide-${shortid.generate()}`} project={project} slider={this} />
            ))}
          </Slider>
        </div>
        <div className={playVideo ? ' banner_slider--hide ' : ''}>
          <button
            type="button"
            className="banner_slider__arrow project_slider__button project_slider__button--big"
            onClick={() => {
              this.previous();
              this.setState({
                autoplay: false,
                videoStarted: false,
                playVideo: false,
              });
            }}
          >
            {LeftArrowIcon('project_slider__icon project_slider__icon--big ')}
          </button>
          <button
            type="button"
            className="banner_slider__arrow banner_slider__arrow--right project_slider__button project_slider__button--big"
            onClick={() => {
              this.next();
              this.setState({
                autoplay: false,
                videoStarted: false,
                playVideo: false,
              });
            }}
          >
            {RightArrowIcon('project_slider__icon project_slider__icon--big ')}
          </button>
        </div>
      </div>
    );
  }

  getContent(setSlider = true) {
    const { playVideo, isFull, pageCount } = this.state;
    return (
      <div>
        <div className={playVideo ? ' banner_slider--hide ' : 'banner_slider__container '}>
          {this.getContentSlider(setSlider)}

          <div className={playVideo ? ' banner_slider--hide ' : ''}>
            <div className="banner_slider__overlay">
              <div
                className={`banner_slider__bg ${isFull ? ' banner_slider__bg--transparent' : ''}`}
              >
                <div className="banner_slider__dots">{this.createDots(pageCount)}</div>
              </div>
            </div>
          </div>
        </div>

        {this.closeFullScreen()}
        {this.getVideoPlayer()}
      </div>
    );
  }

  closeFullScreen() {
    const { isFull, playVideo } = this.state;
    const { closeFull } = this.props;
    return (
      <div>
        {isFull
          && !playVideo && (
            <button
              type="button"
              className="banner_slider__arrow banner_slider__close--top_right  project_slider__button banner_slider__close "
              onClick={closeFull}
            >
              {CloseIcon('project_slider__icon project_slider__icon--big')}
            </button>
        )}
      </div>
    );
  }

  render() {
    return <div>{this.getContent()}</div>;
  }
}

export default IOSImageSlider;



// WEBPACK FOOTER //
// ./src/components/Sliders/IOSImageSlider.js